export enum BadgePlacements {
  TOP = 'top',
  LEFT = 'left',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  TR = 'topRight',
}
export enum ModalProps {
  CONFIRM_TEXT = 'Confirm',
  TEXT_LINE = 'Dui mauris augue, efficitur eu arcu',
  EMPTY_STRING = '',
}

export enum ButtonProps {
  COLOR = 'delete',
}
export enum ButtonLabels {
  CONFIRM = 'Confirm',
  DELETE = 'Delete',
  CANCEL = 'Cancel',
}
